export default "__VITE_ASSET__Bcq6kVtE__"